import * as routeConstants from "./const/route/Route";

export default {
  items: [
    {
      name: 'Notification',
      url: `${routeConstants.NOTIFICATION_ROUTE_PATH}/notification-panel`,
      icon: 'icon-chart',
      children: [
        {
          name: 'Single User Notification',
          url: '/notification-panel/single/create', // ok 1
          icon: 'icon-bell',
        },
        {
          name: 'Category Notification',
          url: '/notification-panel/category/create', // ok 1
          icon: 'icon-bell',
        }
      ]
    }
  ],
};
